import {logUtishaDebug, logUtishaError} from '../../../util/log';

export type AsyncSessionResult = Promise<SessionResult>

export abstract class SessionResult {

  static ok = {
    failure: undefined
  } as SessionResult

  static failure(msg: string) {
    return {
      failure: {
        errorCode: 'Internal Error',
        errorMessage: msg
      } as SessionResultFailure
    } as SessionResult
  }

  get success() {
    return !this.failure
  }

  abstract get originalResult(): any

  abstract failure?: SessionResultFailure

  log(): void {
    if (this.failure) {
      this.failure?.log()
    } else {
      logUtishaDebug('Success')
    }
  }
}

export const ok = {
  failure: undefined
} as SessionResult

export abstract class SessionResultFailure {
  abstract errorCode: string
  abstract errorMessage: string
  abstract error?: Error

  log(): void {
    if (this.error) {
      logUtishaError(this.error.toString())
    } else {
      logUtishaError(this.errorMessage)
    }
  }
}
